import styled from 'styled-components';
import { breakpoints, mediaQuery } from '../utils-css/media-query';

export const Container = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: ${breakpoints.md};
  ${({ theme }): string => theme.mixins.padding({ hor: 1, ver: 0 })};

  ${mediaQuery.minWidth.md}  {
    ${({ theme }): string => theme.mixins.padding({ hor: 0, ver: 0 })};
  },
`;
